import DashboardLayout from "../components/dashboard-layout";
import { useAuth } from "../App";
import { Link } from "react-router-dom";

const QUICK_CARDS = [
  { icon: "📋", title: "Template Kode", desc: "17+ template siap pakai Arduino, ESP32, NodeMCU", color: "#F59E0B", bg: "rgba(245,158,11,0.08)", path: "/template" },
  { icon: "🤖", title: "Chatbot AI", desc: "Tanya spesialis IoT & Arduino 24/7", color: "#1565C0", bg: "rgba(21,101,192,0.08)", path: "/chatbot" },
];

const STATS = [
  { icon: "📋", label: "Template Tersedia", value: "17+", color: "#F59E0B", bg: "rgba(245,158,11,0.1)" },
  { icon: "🤖", label: "AI Chatbot", value: "24/7", color: "#1565C0", bg: "rgba(21,101,192,0.1)" },
  { icon: "🔌", label: "Platform Didukung", value: "4", color: "#10B981", bg: "rgba(16,185,129,0.1)" },
  { icon: "🏛️", label: "Institusi", value: "UM", color: "#8B5CF6", bg: "rgba(139,92,246,0.1)" },
];

const PLATFORMS = [
  { name: "Arduino Uno/Nano", icon: "🔵", count: 7 },
  { name: "NodeMCU ESP8266", icon: "🟢", count: 4 },
  { name: "ESP32", icon: "🟡", count: 4 },
  { name: "Raspberry Pi", icon: "🔴", count: 2 },
];

function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return "Selamat pagi";
  if (h < 15) return "Selamat siang";
  if (h < 18) return "Selamat sore";
  return "Selamat malam";
}

export default function Dashboard() {
  const { user } = useAuth();
  const firstName = user?.name?.split(" ")[0] || "Pengguna";

  return (
    <DashboardLayout>
      <div className="db-page">
        {/* Greeting Hero */}
        <div className="db-hero">
          <div className="db-hero-circle db-hero-circle-1" />
          <div className="db-hero-circle db-hero-circle-2" />
          <div className="db-hero-inner">
            <div className="db-greeting-badge">👋 Halo!</div>
            <h1 className="db-greeting-title">{getGreeting()}, {firstName}!</h1>
            <p className="db-greeting-sub">Selamat datang kembali di AiDuNode. Apa yang ingin kamu pelajari hari ini?</p>
            <div className="db-hero-btns">
              <Link to="/chatbot" className="btn btn-ghost btn-lg">🤖 Tanya AI Sekarang</Link>
              <Link to="/template" className="btn" style={{ background: "#fff", color: "#1565C0", fontWeight: 700 }}>📋 Lihat Template</Link>
            </div>
          </div>
        </div>

        {/* Stats Row */}
        <div className="db-stats-row">
          {STATS.map((s, i) => (
            <div key={i} className="db-stat-card" style={{ "--stat-color": s.color }}>
              <div className="db-stat-icon" style={{ background: s.bg }}>{s.icon}</div>
              <div className="db-stat-val">{s.value}</div>
              <div className="db-stat-label">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Quick Access */}
        <section className="db-section">
          <h2 className="db-section-title">⚡ Akses Cepat</h2>
          <div className="db-quick-grid">
            {QUICK_CARDS.map((c, i) => (
              <Link key={i} to={c.path} className="db-quick-card" style={{ "--qc-color": c.color, "--qc-bg": c.bg }}>
                <div className="db-quick-icon">{c.icon}</div>
                <div>
                  <div className="db-quick-title">{c.title}</div>
                  <div className="db-quick-desc">{c.desc}</div>
                </div>
                <span className="db-quick-arrow">→</span>
              </Link>
            ))}
          </div>
        </section>

        {/* Platforms */}
        <section className="db-section">
          <h2 className="db-section-title">🔌 Platform yang Didukung</h2>
          <div className="db-platform-grid">
            {PLATFORMS.map((p, i) => (
              <div key={i} className="db-platform-card">
                <span className="db-platform-icon">{p.icon}</span>
                <span className="db-platform-name">{p.name}</span>
                <span className="db-platform-count">{p.count} template</span>
              </div>
            ))}
          </div>
        </section>

        {/* Tips */}
        <section className="db-section">
          <div className="db-tip-card">
            <div className="db-tip-icon">💡</div>
            <div>
              <div className="db-tip-title">Tips: Mulai dari Template!</div>
              <p className="db-tip-desc">Pilih template yang sesuai proyekmu, copy kodenya, lalu tanya Chatbot AI jika ada yang perlu disesuaikan. Lebih cepat dan efisien!</p>
            </div>
          </div>
        </section>
      </div>
    </DashboardLayout>
  );
}
